// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"127":"d306a2ad","195":"2d10e3ee","325":"add72ffc","553":"31691541","575":"fa533558","859":"8d9633a0"}[chunkId] + ".chunk.css";
};